module.exports = __webpack_public_path__ + "img/operator3_modal.aaef1001.png";